import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideUserIdleConfig } from './user-idle.provider';
import { UserIdleConfig } from './user-idle.type';
import { UserIdleService } from './user-idle.service';

@NgModule({
  imports: [],
})
export class UserIdleModule {
  static forRoot(config: UserIdleConfig): ModuleWithProviders<UserIdleModule> {
    return {
      ngModule: UserIdleModule,
      providers: [UserIdleService, ...provideUserIdleConfig(config)],
    };
  }
}
